import evn from "./../../actions/index"; //action的所有事件
var EventSet = {
  //金额格式化
  numberFormat: function(nums, s) {
    var num;
    var result = "";
    var dot = "";
    var minus = "";
    if (nums || Number(nums) === 0) {
      num = (nums * 1).toFixed(s).toString();
      if (num.indexOf("-") > -1) {
        minus = "-";
        num = num.split("-")[1];
      }
      if (num.indexOf(".") > -1) {
        var newnum = num.split(".");
        num = newnum[0];
        dot = newnum[1];
      }
      while (num.length > 3) {
        result = "," + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }
      if (num) {
        s
          ? (result = minus + num + result + "." + dot)
          : (result = minus + num + result);
      }
    }
    return result;
  },
  //日期格式化日期
  GetDate: function(now, itype) {
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var date = now.getDate();
    var hour = now.getHours();
    var minute = now.getMinutes();
    var second = now.getSeconds();
    if (itype === "yyyy-MM-dd hh:mm:ss")
      return (
        year +
        "-" +
        month +
        "-" +
        date +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second
      );
    else if (itype === "yyyy-MM-dd hh:mm")
      return (
        year +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (date < 10 ? "0" + date : date) +
        " " +
        (hour < 10 ? "0" + hour : hour) +
        ":" +
        (minute < 10 ? "0" + minute : minute)
      );
    else if (itype === "yyyy-MM-dd") return year + "-" + month + "-" + date;
    else if (itype === "yyyy-MM") return year + "-" + month;
    else if (itype === "MM-dd") return month + "-" + date;
  },

  //得到字符总数
  getChars: function(str) {
    var i = 0;
    var c = 0.0;
    var unicode = 0;
    var len = 0;

    if (str === null || str === "") {
      return 0;
    }
    len = str.length;
    for (i = 0; i < len; i++) {
      unicode = str.charCodeAt(i);
      if (unicode < 127) {
        //判断是单字符还是双字符
        c += 1;
      } else {
        //chinese
        c += 2;
      }
    }
    return c;
  },

  //页面抖动一下
  PageDo: function() {
    setTimeout(function() {
      if (document.createEvent) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent("resize", true, true);
        window.dispatchEvent(event);
      } else if (document.createEventObject) {
        window.fireEvent("onresize");
      }
    }, 1);
  },

  //倒计时
  getSurplusTime: function(data) {
    let date1 = data; //开始时间
    let date2 = new Date(); //结束时间
    let date3 = date2.getTime() - new Date(date1).getTime(); //时间差的毫秒数

    //计算出相差天数
    let days = Math.floor(date3 / (24 * 3600 * 1000));

    //计算出小时数
    let leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
    let hours = Math.floor(leave1 / (3600 * 1000));
    //计算相差分钟数
    let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
    let minutes = Math.floor(leave2 / (60 * 1000));
    //计算相差秒数
    let leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
    let seconds = Math.round(leave3 / 1000);

    hours = 23 - hours;
    minutes = 59 - minutes;
    seconds = 60 - seconds;
    let arr = [];
    arr[0] = days;
    arr[1] = hours >= 10 ? hours : "0" + hours;
    arr[2] = minutes >= 10 ? minutes : "0" + minutes;
    arr[3] = seconds >= 10 ? seconds : "0" + seconds;
    return arr;
  },

  //返回菜单数组
  getNavArr(openkey) {
    let openkeys = [];
    openkeys[0] = openkey;
    return openkeys;
  },

  //菜单显示
  NavShow: function(that, selectKey, openKey) {
    that.props.dispatch(evn.changeNavSelectkey(EventSet.getNavArr(selectKey)));
    that.props.dispatch(evn.changeNavOpenkey(EventSet.getNavArr(openKey)));
  },

  //获取用户信息
  getUserInfo() {
    return window.localStorage["userInfo"]
      ? JSON.parse(window.localStorage["userInfo"])
      : {};
  },

  //设置cookie
  setCookie: function(name, value, time) {
    var strsec = EventSet.getsec(time);
    var exp = new Date();
    exp.setTime(exp.getTime() + strsec * 1);
    document.cookie = name + "=" + value + ";expires=" + exp.toGMTString();
  },
  //获取cookie

  getCookie: function(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1);
      if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
    }
    return "";
  },

  //转换过期时间，s20是代表20秒，m12是代表12分钟,h12是代表20小时，d30是代表30天
  getsec: function(str) {
    var str1 = str.substring(1, str.length) * 1;
    var str2 = str.substring(0, 1);
    if (str2 == "s") {
      return str1 * 1000;
    } else if (str2 == "m") {
      return str1 * 60 * 1000;
    } else if (str2 == "h") {
      return str1 * 60 * 60 * 1000;
    } else if (str2 == "d") {
      return str1 * 24 * 60 * 60 * 1000;
    }
  },

  //删除cookies
  clearCookie: function(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = EventSet.getCookie(name);
    if (cval != null)
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
  },

  ajax: function(opt) {
    opt = opt || {};
    opt.type = opt.type.toUpperCase() || "POST";
    opt.url = opt.url || "";
    opt.async = opt.async == true;
    opt.data = opt.data || null;
    opt.success = opt.success || function() {};
    opt.error = opt.error || function() {};
    //opt.crossDomain = (true == !(document.all));
    var xmlHttp = null;
    if (XMLHttpRequest) {
      xmlHttp = new XMLHttpRequest();
    } else {
      xmlHttp = new window.ActiveXObject("Microsoft.XMLHTTP");
    }

    var params = [];
    for (var key in opt.data) {
      if (opt.type.toUpperCase() === "GET")
        params.push(
          key + "=" + encodeURIComponent(encodeURIComponent(opt.data[key]))
        );
      //解决IE中文出错
      else params.push(key + "=" + opt.data[key]);
    }
    var postData = params.join("&");
    if (opt.type.toUpperCase() === "POST") {
      xmlHttp.open(opt.type, opt.url, opt.async);
      xmlHttp.setRequestHeader(
        "Content-Type",
        "application/x-www-form-urlencoded;charset=utf-8"
      );
      xmlHttp.send(postData);
    } else if (opt.type.toUpperCase() === "GET") {
      if (postData == "") postData = "1=1";
      xmlHttp.open(
        opt.type,
        opt.url + "?" + postData + "&t=" + new Date().getTime(),
        opt.async
      ); //增加时间戳避免缓存
      xmlHttp.send(null);
    }
    if (opt.async) {
      //异步
      xmlHttp.onreadystatechange = function() {
        if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
          opt.success(xmlHttp.responseText);
        } else if (xmlHttp.status >= 400) {
          opt.error(xmlHttp.status + ":" + xmlHttp.responseText);
        }
      };
    } else {
      //同步
      var result = xmlHttp.status;
      if (result == 200) {
        opt.success(xmlHttp.responseText);
      } else if (result >= 400) {
        opt.error(xmlHttp.status + ":" + xmlHttp.responseText);
      }
    }
  },

  getQueryString: function(paramName) {
    var name, value;
    var str = window.location.href; //取得整个地址栏
    var num = str.indexOf("?");
    str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]

    var arr = str.split("&"); //各个参数放到数组里
    for (var i = 0; i < arr.length; i++) {
      num = arr[i].indexOf("=");
      if (num > 0) {
        name = arr[i].substring(0, num);
        value = arr[i].substr(num + 1);
        this[name] = value;
      }
    }
    return this[paramName];
  },
  //滑动验证
  slide: function() {
    const l = 42, // 滑块边长
      r = 10, // 滑块半径
      w = document.getElementById("captcha").clientWidth, // canvas宽度
      h = 155, // canvas高度
      PI = Math.PI;
    const L = l + r * 2; // 滑块实际边长
    localStorage.setItem("slideTest", "false");
    localStorage.setItem("slideMove", "false");

    function getRandomNumberByRange(start, end) {
      return Math.round(Math.random() * (end - start) + start);
    }

    function createCanvas(width, height) {
      const canvas = createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      return canvas;
    }

    function createImg(onload) {
      const img = createElement("img");
      img.crossOrigin = "Anonymous";
      img.onload = onload;
      img.onerror = () => {
        img.src = getRandomImg();
      };
      img.src = getRandomImg();
      return img;
    }

    function createElement(tagName) {
      return document.createElement(tagName);
    }

    function addClass(tag, className) {
      tag.classList.add(className);
    }

    function removeClass(tag, className) {
      tag.classList.remove(className);
    }

    function getRandomImg() {
      return (
        "https://webservice.jshcsoft.com/slideImages/test" +
        getRandomNumberByRange(1, 15) +
        ".jpg"
      );
    }

    function draw(ctx, operation, x, y) {
      ctx.beginPath();
      ctx.moveTo(x, y);
      ctx.lineTo(x + l / 2, y);
      ctx.arc(x + l / 2, y - r + 2, r, 0, 2 * PI);
      ctx.lineTo(x + l / 2, y);
      ctx.lineTo(x + l, y);
      ctx.lineTo(x + l, y + l / 2);
      ctx.arc(x + l + r - 2, y + l / 2, r, 0, 2 * PI);
      ctx.lineTo(x + l, y + l / 2);
      ctx.lineTo(x + l, y + l);
      ctx.lineTo(x, y + l);
      ctx.lineTo(x, y);
      ctx.fillStyle = "#fff";
      ctx[operation]();
      ctx.beginPath();
      ctx.arc(x, y + l / 2, r, 1.5 * PI, 0.5 * PI);
      ctx.globalCompositeOperation = "xor";
      ctx.fill();
    }

    function sum(x, y) {
      return x + y;
    }

    function square(x) {
      return x * x;
    }

    class jigsaw {
      constructor(el, success, fail) {
        this.el = el;
        this.success = success;
        this.fail = fail;
      }

      init() {
        this.initDOM();
        this.initImg();
        this.draw();
        this.bindEvents();
      }

      initDOM() {
        const canvas = createCanvas(w, h); // 画布
        const block = canvas.cloneNode(true); // 滑块
        const sliderContainer = createElement("div");
        const refreshIcon = createElement("div");
        const sliderMask = createElement("div");
        const slider = createElement("div");
        const sliderIcon = createElement("span");
        const text = createElement("span");
        const canvasDiv = createElement("div");

        block.className = "block";
        sliderContainer.className = "sliderContainer";
        refreshIcon.className = "refreshIcon";
        sliderMask.className = "sliderMask";
        slider.className = "slider";
        sliderIcon.className = "sliderIcon";
        text.innerHTML = "向右滑动滑块填充拼图";
        text.className = "sliderText";
        canvasDiv.className = "sliderShowPic";

        const el = this.el;
        canvasDiv.appendChild(canvas);
        canvasDiv.appendChild(refreshIcon);
        canvasDiv.appendChild(block);
        el.appendChild(canvasDiv);
        // el.appendChild(canvas)
        // el.appendChild(refreshIcon)
        // el.appendChild(block)
        slider.appendChild(sliderIcon);
        sliderMask.appendChild(slider);
        sliderContainer.appendChild(sliderMask);
        sliderContainer.appendChild(text);
        el.appendChild(sliderContainer);

        Object.assign(this, {
          canvas,
          block,
          sliderContainer,
          refreshIcon,
          slider,
          sliderMask,
          sliderIcon,
          text,
          canvasCtx: canvas.getContext("2d"),
          blockCtx: block.getContext("2d"),
        });
      }

      initImg() {
        const img = createImg(() => {
          this.canvasCtx.drawImage(img, 0, 0, w, h);
          this.blockCtx.drawImage(img, 0, 0, w, h);
          const y = this.y - r * 2 + 2;
          const ImageData = this.blockCtx.getImageData(this.x, y, L, L);
          this.block.width = L;
          this.blockCtx.putImageData(ImageData, 0, y);
        });
        this.img = img;
      }

      draw() {
        // 随机创建滑块的位置
        this.x = getRandomNumberByRange(L + 10, w - (L + 10));
        this.y = getRandomNumberByRange(10 + r * 2, h - (L + 10));
        draw(this.canvasCtx, "fill", this.x, this.y);
        draw(this.blockCtx, "clip", this.x, this.y);
      }

      clean() {
        this.canvasCtx.clearRect(0, 0, w, h);
        this.blockCtx.clearRect(0, 0, w, h);
        this.block.width = w;
      }

      bindEvents() {
        this.el.onselectstart = () => false;
        this.refreshIcon.onclick = () => {
          this.reset();
        };

        let originX,
          originY,
          trail = [],
          isMouseDown = false;

        this.slider.addEventListener("mousedown", function(e) {
          if (localStorage.getItem("slideTest") == "false") {
            document.getElementsByClassName("sliderShowPic")[0].style.display =
              "block";
            (originX = e.x), (originY = e.y);
            isMouseDown = true;
          }
        });
        document.addEventListener("mousemove", (e) => {
          if (!isMouseDown) return false;
          const moveX = e.x - originX;
          const moveY = e.y - originY;
          if (moveX < 0 || moveX + 38 >= w) return false;
          this.slider.style.left = moveX + "px";
          var blockLeft = ((w - 40 - 20) / (w - 40)) * moveX;
          this.block.style.left = blockLeft + "px";

          addClass(this.sliderContainer, "sliderContainer_active");
          this.sliderMask.style.width = moveX + "px";
          trail.push(moveY);
        });
        document.addEventListener("mouseup", (e) => {
          if (!isMouseDown) return false;
          isMouseDown = false;
          if (e.x == originX) return false;
          removeClass(this.sliderContainer, "sliderContainer_active");
          this.trail = trail;
          const { spliced, TuringTest } = this.verify();
          localStorage.setItem("slideMove", "true");
          if (spliced) {
            if (TuringTest) {
              addClass(this.sliderContainer, "sliderContainer_success");
              this.success && this.success();
              localStorage.setItem("slideTest", "true");

              setTimeout(() => {
                //this.reset()
                document.getElementsByClassName(
                  "sliderShowPic"
                )[0].style.display = "none";
              }, 300);
            } else {
              addClass(this.sliderContainer, "sliderContainer_fail");
              this.text.innerHTML = "再试一次";
              localStorage.setItem("slideTest", "false");
              this.reset();
            }
          } else {
            addClass(this.sliderContainer, "sliderContainer_fail");
            this.fail && this.fail();
            localStorage.setItem("slideTest", "false");

            setTimeout(() => {
              this.reset();
              document.getElementsByClassName(
                "sliderShowPic"
              )[0].style.display = "none";
            }, 1000);
          }
        });
      }

      verify() {
        const arr = this.trail; // 拖动时y轴的移动距离
        const average = arr.reduce(sum) / arr.length; // 平均值
        const deviations = arr.map((x) => x - average); // 偏差数组
        const stddev = Math.sqrt(
          deviations.map(square).reduce(sum) / arr.length
        ); // 标准差
        const left = parseInt(this.block.style.left);
        return {
          spliced: Math.abs(left - this.x) < 10,
          TuringTest: average !== stddev, // 只是简单的验证拖动轨迹，相等时一般为0，表示可能非人为操作
        };
      }

      reset() {
        this.sliderContainer.className = "sliderContainer";
        this.slider.style.left = 0;
        this.block.style.left = 0;
        this.sliderMask.style.width = 0;
        this.clean();
        this.img.src = getRandomImg();
        this.draw();
      }
    }

    let slideVerify = "";
    window.jigsaw = {
      //初始化滑动验证
      init: function(element, success, fail) {
        slideVerify = new jigsaw(element, success, fail);
        slideVerify.init();
      },
      //重置滑动验证
      reset: function() {
        slideVerify.reset();
      },
    };
  },

  //websocket
  getWebsocket: function() {
    var conn;
    if (window["WebSocket"]) {
      conn = new WebSocket(
        "ws://211.149.250.2:8083/ws?moduleId=Home&token=" +
          JSON.parse(localStorage.getItem("userInfo")).loginName
      );
      return conn;
      //conn.onclose = function (evt) {
      //};
      //conn.onmessage = function (evt) {
      //    var messages = evt.data.split('\n');
      //    for (var i = 0; i < messages.length; i++) {
      //        switch (messages[0]) {
      //            case "0":
      //                alert("您的账号在其他地方登陆，如非本人操作，请及时修改密码！")
      //                history.push({ pathname: '/Login/LoginMain/LoginEntry', })
      //                break;
      //            default:
      //                alert(messages[0])
      //                break;
      //        }
      //        if (messages[i] == 0) {

      //        }
      //    }
      //};
    } else {
      var item = document.createElement("div");
      item.innerHTML = "<b>Your browser does not support WebSockets.</b>";
      appendLog(item);
    }
  },

  Base64: function() {
    // private property
    let _keyStr =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

    // public method for encoding
    this.encode = function(input) {
      var output = "";
      var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      var i = 0;
      input = _utf8_encode(input);
      while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output =
          output +
          _keyStr.charAt(enc1) +
          _keyStr.charAt(enc2) +
          _keyStr.charAt(enc3) +
          _keyStr.charAt(enc4);
      }
      return output;
    };

    // public method for decoding
    this.decode = function(input) {
      var output = "";
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
      while (i < input.length) {
        enc1 = _keyStr.indexOf(input.charAt(i++));
        enc2 = _keyStr.indexOf(input.charAt(i++));
        enc3 = _keyStr.indexOf(input.charAt(i++));
        enc4 = _keyStr.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3);
        }
      }
      output = _utf8_decode(output);
      return output;
    };

    // private method for UTF-8 encoding
    var _utf8_encode = function(string) {
      string = string.replace(/\r\n/g, "\n");
      var utftext = "";
      for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n);
        if (c < 128) {
          utftext += String.fromCharCode(c);
        } else if (c > 127 && c < 2048) {
          utftext += String.fromCharCode((c >> 6) | 192);
          utftext += String.fromCharCode((c & 63) | 128);
        } else {
          utftext += String.fromCharCode((c >> 12) | 224);
          utftext += String.fromCharCode(((c >> 6) & 63) | 128);
          utftext += String.fromCharCode((c & 63) | 128);
        }
      }
      return utftext;
    };

    // private method for UTF-8 decoding
    var _utf8_decode = function(utftext) {
      var string = "";
      var i = 0;
      var c1 = 0;
      var c2 = 0;
      var c3 = 0;
      var c = 0;
      while (i < utftext.length) {
        c = utftext.charCodeAt(i);
        if (c < 128) {
          string += String.fromCharCode(c);
          i++;
        } else if (c > 191 && c < 224) {
          c2 = utftext.charCodeAt(i + 1);
          string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
          i += 2;
        } else {
          c2 = utftext.charCodeAt(i + 1);
          c3 = utftext.charCodeAt(i + 2);
          string += String.fromCharCode(
            ((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
          );
          i += 3;
        }
      }
      return string;
    };
  },

  //密码分数
  returnScore: function(origin) {
    // 接连重复字元数
    function findRepeatLetter(origin) {
      // debugger
      if (origin && origin.length > 1) {
        let i = 0;
        let j = 1;
        let arr = [];
        while (i < origin.length) {
          if (origin.charAt(i) == origin.charAt(j)) {
            j++;
          } else {
            arr.push(origin.slice(i, j));
            i = j;
            j++;
          }
        }
        let filterEles = arr.filter((item) => {
          return item.length >= 2;
        });
        let repeatLetters = filterEles.join("");
        if (repeatLetters.length > 0) {
          return repeatLetters.length * 2;
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    }
    // 接连数字/字母字元数
    function findConsecutive(origin, regExp) {
      if (origin && origin.length > 1) {
        let i = 0;
        let j = 1;
        let arr = [];
        while (i < origin.length) {
          if (regExp.test(origin.charAt(i)) && regExp.test(origin.charAt(j))) {
            j++;
          } else {
            arr.push(origin.slice(i, j));
            i = j;
            j++;
          }
        }

        let filterEles = arr.filter((item) => {
          return item.length >= 2;
        });
        let consecutiveLetters = filterEles.join("");
        if (consecutiveLetters.length > 3) {
          return consecutiveLetters.length - 3;
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    }
    // 3码以上的连续数字/字母字元数
    function findSequential(origin, regExp) {
      if (origin && origin.length >= 3) {
        let i = 0;
        let j = 1;
        let k = 2;

        let arr = [];
        while (i < origin.length - 2) {
          let checki = regExp.test(origin.charAt(i));
          let checkj = regExp.test(origin.charAt(j));
          let checkk = regExp.test(origin.charAt(k));
          let cond1 = checki && checkj && checkk;

          let numi;
          let numj;
          let numk;
          if (!isNaN(origin.charAt(i))) {
            numi = parseInt(origin.charAt(i));
            numj = parseInt(origin.charAt(j));
            numk = parseInt(origin.charAt(k));
          }

          if (isNaN(origin.charAt(i))) {
            numi = origin.charAt(i).charCodeAt();
            numj = origin.charAt(j).charCodeAt();
            numk = origin.charAt(k).charCodeAt();
          }
          let cond2 =
            (j == i + 1 &&
              Math.abs(numj - numi) == 1 &&
              Math.abs(numk - numj) == 1) ||
            (j > i + 1 && Math.abs(numk - numj) == 1);
          if (cond1 && cond2) {
            j++;
            k++;
          } else {
            arr.push(origin.slice(i, k));
            i = j;
            j++;
            k++;
          }
        }

        let filterEles = arr.filter((item) => {
          return item.length >= 3;
        });
        let sequentialLetters = filterEles.join("");
        if (sequentialLetters.length >= 3) {
          return sequentialLetters.length * 3;
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    }

    function four(pass, isAll = false) {
        var flag = false;
        var passLower = isAll ? pass.toLowerCase() : pass;
        for (var i = 0; i < passLower.length - 3; i++) {
            if (passLower[i] == passLower[i + 1] &&
                passLower[i + 1] == passLower[i + 2] &&
                passLower[i + 2] == passLower[i + 3]) {
                flag = true;
            }
        }
        return flag;
    }

    function hasWeakCommonWord(password) {
        let regStr = /admin|password|sangfor|anonymous|hello|welcome|talent|huawei|window|system|iloveyou|letmein|football|monkey|starwars|dragon|passw0rd|maste|freedom|whatever|qazwsx|trust|number|imagine|cinema|zero|lights|wordpress|oracle|123456|password|12345678|qwerty|123456789|12345|1234|111111|1234567|dragon|123123|baseball|abc123|football|monkey|letmein|696969|shadow|master|666666|qwertyuiop|123321|mustang|1234567890|michael|654321|pussy|superman|1qaz2wsx|7777777|fuckyou|121212|000000|qazwsx|123qwe|killer|trustno1|jordan|jennifer|zxcvbnm|asdfgh|hunter|buster|soccer|harley|batman|andrew|tigger|sunshine|iloveyou|fuckme|2000|charlie|robert|thomas|hockey|ranger|daniel|starwars|klaster|112233|george|asshole|computer|michelle|jessica|pepper|1111|zxcvbn|555555|11111111|131313|freedom|777777|pass|fuck|maggie|159753|aaaaaa|ginger|princess|joshua|cheese|amanda|summer|love|ashley|6969|nicole|chelsea|biteme|matthew|access|yankees|987654321|dallas|austin|thunder|taylor|matrix|william|corvette|hello|martin|heather|secret|fucker|merlin|diamond|1234qwer|gfhjkm|hammer|silver|222222|88888888|anthony|justin|test|bailey|q1w2e3r4t5|patrick|internet|scooter|orange|11111|golfer|cookie|richard|samantha|bigdog|guitar|jackson|whatever|mickey|chicken|sparky|snoopy|maverick|phoenix|camaro|sexy|peanut|morgan|welcome|falcon|cowboy|ferrari|samsung|andrea|smokey|steelers|joseph|mercedes|dakota|arsenal|eagles|melissa|boomer|booboo|spider|nascar|monster|tigers|yellow|xxxxxx|123123123|gateway|marina|diablo|bulldog|qwer1234|compaq|purple|hardcore|banana|junior|hannah|123654|porsche|lakers|iceman|money|cowboys|987654|london|tennis|999999|ncc1701|coffee|scooby|0000|miller|boston|q1w2e3r4|fuckoff|brandon|yamaha|chester|mother|forever|johnny|edward|333333|oliver|redsox|player|nikita|knight|fender|barney|midnight|please|brandy|chicago|badboy|iwantu|slayer|rangers|charles|angel|flower|bigdaddy|rabbit|wizard|bigdick|jasper|enter|rachel|chris|steven|winner|adidas|victoria|natasha|1q2w3e4r|jasmine|winter|prince|panties|marine|ghbdtn|fishing|cocacola|casper|james|232323|raiders|888888|marlboro|gandalf|asdfasdf|crystal|87654321|12344321|sexsex|golden|blowme|bigtits|8675309|panther|lauren|angela|bitch|spanky|thx1138|angels|madison|winston|shannon|mike|toyota|blowjob|jordan23|canada|sophie|Password|apples|dick|tiger|razz|123abc|pokemon|qazxsw|55555|qwaszx|muffin|johnson|murphy|cooper|jonathan|liverpoo|david|danielle|159357|jackie|1990|123456a|789456|turtle|horny|abcd1234|scorpion|qazwsxedc|101010|butter|carlos|password1|dennis|slipknot|qwerty123|booger|asdf|1991|black|startrek|12341234|cameron|newyork|rainbow|nathan|john|1992|rocket|viking|redskins|butthead|asdfghjkl|1212|sierra|peaches|gemini|doctor|wilson|sandra|helpme|qwertyui|victor|florida|dolphin|pookie|captain|tucker|blue|liverpool|theman|bandit|dolphins|maddog|packers|jaguar|lovers|nicholas|united|tiffany|maxwell|zzzzzz|nirvana|jeremy|suckit|stupid|porn|monica|elephant|giants|jackass|hotdog|rosebud|success|debbie|mountain|444444|xxxxxxxx|warrior|1q2w3e4r5t|q1w2e3|123456q|albert|metallic|lucky|azerty|7777|shithead|alex|bond007|alexis|1111111|samson|5150|willie|scorpio|bonnie|gators|benjamin|voodoo|driver|dexter|2112|jason|calvin|freddy|212121|creative|12345a|sydney|rush2112|1989|asdfghjk|red123|bubba|4815162342|passw0rd|trouble|gunner|happy|fucking|gordon|legend|jessie|stella|qwert|eminem|arthur|apple|nissan|bullshit|bear|america|1qazxsw2|nothing|parker|4444|rebecca|qweqwe|garfield|01012011|beavis|69696969|jack|asdasd|december|2222|102030|252525|11223344|magic|apollo|skippy|315475|girls|kitten|golf|copper|braves|shelby|godzilla|beaver|fred|tomcat|august|buddy|airborne|1993|1988|lifehack|qqqqqq|brooklyn|animal|platinum|phantom|online|xavier|darkness|blink182|power|fish|green|789456123|voyager|police|travis|12qwaszx|heaven|snowball|lover|abcdef|00000|pakistan|007007|walter|playboy|blazer|cricket|sniper|hooters|donkey|willow|loveme|saturn|therock|redwings|bigboy|pumpkin|trinity|williams|tits|nintendo|digital|destiny|topgun|runner|marvin|guinness|chance|bubbles|testing|fire|november|minecraft|asdf1234|lasvegas|sergey|broncos|cartman|private|celtic|birdie|little|cassie|babygirl|donald|beatles|1313|dickhead|family|12121212|school|louise|gabriel|eclipse|fluffy|147258369|lol123|explorer|beer|nelson|flyers|spencer|scott|lovely|gibson|doggie|cherry|andrey|snickers|buffalo|pantera|metallica|member|carter|qwertyu|peter|alexande|steve|bronco|paradise|goober|5555|samuel|montana|mexico|dreams|michigan|cock|carolina|yankee|friends|magnum|surfer|poopoo|maximus|genius|cool|vampire|lacrosse|asd123|aaaa|christin|kimberly|speedy|sharon|carmen|111222|kristina|sammy|racing|ou812|sabrina|horses|0987654321|qwerty1|pimpin|baby|stalker|enigma|147147|star|poohbear|boobies|147258|simple|bollocks|12345q|marcus|brian|1987|qweasdzxc|drowssap|hahaha|caroline|barbara|dave|viper|drummer|action|einstein|bitches|genesis|hello1|scotty|friend|forest|010203|hotrod|google|vanessa|spitfire|badger|maryjane|friday|alaska|1232323q|tester|jester|jake|champion|billy|147852|rock|hawaii|badass|chevy|420420|walker|stephen|eagle1|bill|1986|october|gregory|svetlana|pamela|1984|music|shorty|westside|stanley|diesel|courtney|242424|kevin|porno|hitman|boobs|mark|12345qwert|reddog|frank|qwe123|popcorn|patricia|aaaaaaaa|1969|teresa|mozart|buddha|anderson|paul|melanie|abcdefg|security|lucky1|lizard|denise|3333|a12345|123789|ruslan|stargate|simpsons|scarface|eagle|123456789a|thumper|olivia|naruto|1234554321|general|cherokee|a123456|vincent|Usuckballz1|spooky|qweasd|cumshot|free|frankie|douglas|death|1980|loveyou|kitty|kelly|veronica|suzuki|semperfi|penguin|mercury|liberty|spirit|scotland|natalie|marley|vikings|system|sucker|king|allison|marshall|1979|098765|qwerty12|hummer|adrian|1985|vfhbyf|sandman|rocky|leslie|antonio|98765432|4321|softball|passion|mnbvcxz|bastard|passport|horney|rascal|howard|franklin|bigred|assman|alexander|homer|redrum|jupiter|claudia|55555555|141414|zaq12wsx|shit|patches|nigger|cunt|raider|infinity|andre|54321|galore|college|russia|kawasaki|bishop|77777777|vladimir|money1|freeuser|wildcats|francis|disney|budlight|brittany|1994|00000000|sweet|oksana|honda|domino|bulldogs|brutus|swordfis|norman|monday|jimmy|ironman|ford|fantasy|9999|7654321|PASSWORD|hentai|duncan|cougar|1977|jeffrey|house|dancer|brooke|timothy|super|marines|justice|digger|connor|patriots|karina|202020|molly|everton|tinker|alicia|rasdzv3|poop|pearljam|stinky|naughty|colorado|123123a|water|test123|ncc1701d|motorola|ireland|asdfg|slut|matt|houston|boogie|zombie|accord|vision|bradley|reggie|kermit|froggy|ducati|avalon|6666|9379992|sarah|saints|logitech|chopper|852456|simpson|madonna|juventus|claire|159951|zachary|yfnfif|wolverin|warcraft|hello123|extreme|penis|peekaboo|fireman|eugene|brenda|123654789|russell|panthers|georgia|smith|skyline|jesus|elizabet|spiderma|smooth|pirate|empire|bullet|8888|virginia|valentin|psycho|predator|arizona|134679|mitchell|alyssa|vegeta|titanic|christ|goblue|fylhtq|wolf|mmmmmm|kirill|indian|hiphop|baxter|awesome|people|danger|roland|mookie|741852963|1111111111|dreamer|bambam|arnold|1981|skipper|serega|rolltide|elvis|changeme|simon|1q2w3e|lovelove|fktrcfylh|denver|tommy|mine|loverboy|hobbes|happy1|alison|nemesis|chevelle|cardinal|burton|wanker|picard|151515|tweety|michael1|147852369|12312|xxxx|windows|turkey|456789|1974|vfrcbv|sublime|1975|galina|bobby|newport|manutd|daddy|american|alexandr|1966|victory|rooster|qqq111|madmax|electric|bigcock|a1b2c3|wolfpack|spring|phpbb|lalala|suckme|spiderman|eric|darkside|classic|raptor|123456789q|hendrix|1982|wombat|avatar|alpha|zxc123|crazy|hard|england|brazil|1978|01011980|wildcat|polina|freepass/;
        return regStr.test(password.toLowerCase())
    }

    function isKeyBoardContinuousChar1(str) {
        str = str.toLowerCase()
        var c1 = [
            ['!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '_', '+'],
            ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', '{', '}', '|'],
            ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', ':', '"'],
            ['z', 'x', 'c', 'v', 'b', 'n', 'm', '<', '>', '?']
        ];
        var c2 = [
            ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '-', '='],
            ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', '[', ']', '\\'],
            ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', ';', '\''],
            ['z', 'x', 'c', 'v', 'b', 'n', 'm', ',', '.', '/']
        ];
        str = str.split("");
        //获取坐标位置
        var y = [];
        var x = [];
        for (var c = 0; c < str.length; c++) {
            y[c] = 0; //当做~`键处理
            x[c] = -1;
            for (var i = 0; i < c1.length; i++) {
                for (var j = 0; j < c1[i].length; j++) {
                    if (str[c] == c1[i][j]) {
                        y[c] = i;
                        x[c] = j;
                    }
                }
            }
            if (x[c] != -1) continue;
            for (var i = 0; i < c2.length; i++) {
                for (var j = 0; j < c2[i].length; j++) {
                    if (str[c] == c2[i][j]) {
                        y[c] = i;
                        x[c] = j;
                    }
                }
            }
        }
        //匹配坐标连线
        for (var c = 1; c < str.length - 1; c++) {
            if (y[c - 1] == y[c] && y[c] == y[c + 1]) {
                if ((x[c - 1] + 1 == x[c] && x[c] + 1 == x[c + 1]) || (x[c + 1] + 1 == x[c] && x[c] + 1 == x[c - 1])) {
                    return true;
                }
            } else if (x[c - 1] == x[c] && x[c] == x[c + 1]) {
                if ((y[c - 1] + 1 == y[c] && y[c] + 1 == y[c + 1]) || (y[c + 1] + 1 == y[c] && y[c] + 1 == y[c - 1])) {
                    return true;
                }
            }
        }
        return false;
    }

    // 总分
    let gradeScore = 70;
    //将输入源转为字符串
    origin = `${origin}`;

    // +(总字元数-8)*4
    gradeScore += (origin.length - 8) * 4;
    // console.log("总字元数：", (origin.length - 8) * 4);

    // +(字母字元数-大写字母字元数)*(字母字元数-小写字母字元数)*2
    let allLetterNum = origin.match(/[a-zA-Z]/g)
      ? origin.match(/[a-zA-Z]/g).length
      : 0;
    let capLetterNum = origin.match(/[A-Z]/g)
      ? origin.match(/[a-zA-Z]/g).length
      : 0;
    let lowLetterNum = origin.match(/[a-z]/g)
      ? origin.match(/[a-zA-Z]/g).length
      : 0;
    gradeScore +=
      (allLetterNum - capLetterNum) * (allLetterNum - lowLetterNum) * 2;
    // console.log(
    //     "大小写字母字元数：",
    //     (allLetterNum - capLetterNum) * (allLetterNum - lowLetterNum) * 2
    // );

    origin = origin.toLowerCase();
    
    if (isKeyBoardContinuousChar1(origin.toLowerCase()) || four(origin) || hasWeakCommonWord(origin) || findSequential(origin, /[a-z]/) >= 1 || findSequential(origin, /[0-9]/) >= 1) {
        return 0
    }

    // -(接连重复字元数)*2
    gradeScore -= findRepeatLetter(origin);
    // console.log("接连重复字元数扣分：", -findRepeatLetter(origin));

    // －(接连(Consecutive)数字字元数－3) × 1
    gradeScore -= findConsecutive(origin, /[0-9]/);
    // console.log(
    //     "接连(Consecutive)数字字元数扣分：",
    //     -findConsecutive(origin, /[0-9]/)
    // );

    //  －(接连(Consecutive)字母字元数－3) × 1
    gradeScore -= findConsecutive(origin, /[a-z]/);
    // console.log(
    //     "接连(Consecutive)小写字母字元数扣分：",
    //     -findConsecutive(origin, /[a-z]/)
    // );

    // －(3码以上的连续(sequential)数字字元数) × 3
    gradeScore -= findSequential(origin, /[0-9]/);
    // console.log(
    //     "3码以上的连续(sequential)数字字元数扣分：",
    //     -findSequential(origin, /[0-9]/)
    // );

    // －(3码以上的连续(sequential)字母字元数) × 3
    gradeScore -= findSequential(origin, /[a-z]/);
    // console.log(
    //     "3码以上的连续(sequential)小写字母字元数扣分：",
    //     -findSequential(origin, /[a-z]/)
    // );
    if (gradeScore > 0) {
      return gradeScore;
    } else {
      return 0;
    }
  },
  returnScore1: function(value) {
    const _this = this;
    let num = 70,
      Aalength = 0,
      ALength = 0,
      Nlength = 0;
    // 字母字数
    value.replace(/[A-Za-z]/g, () => {
      Aalength++;
    });
    // 大写字母字数
    value.replace(/[A-Z]/g, () => {
      ALength++;
    });
    // ASCII码集合
    let ascCode = value.split("").map((si) => {
      return si.charCodeAt();
    });
    // 通过ASCII判断重复个数
    let repeatList = [];
    ascCode.reduce((a, b, index) => {
      if (a === b) {
        repeatList.push(index - 1);
        repeatList.push(index);
      }
      return b;
    });
    repeatList = Array.from(new Set(repeatList));
    // 通过格式判断数字和字母的重复个数
    let numRepeat = [],
      strRepeat = [];
    value.split("").reduce((a, b, index) => {
      if (_this.myIsNaN(Number(a)) && _this.myIsNaN(Number(b))) {
        numRepeat.push(index - 1);
        numRepeat.push(index);
      } else if (/[A-Za-z]/g.test(a) && /[A-Za-z]/g.test(b)) {
        strRepeat.push(index - 1);
        strRepeat.push(index);
      }
      return b;
    });
    let numIndex = [];
    Array.from(new Set(numRepeat)).length > 0
      ? Array.from(new Set(numRepeat)).reduce((a, b, index) => {
          if (b - a !== 1) {
            numIndex.push(index - 1);
          }
          return b;
        })
      : numIndex;
    if (numIndex.length > 0) {
      numIndex.unshift(0);
      numIndex.push(
        Array.from(new Set(numRepeat))[
          Array.from(new Set(numRepeat)).length - 1
        ]
      );
      let listt = [];
      numIndex.reduce((a, b) => {
        listt.push(b - a);
        return b;
      });
      numRepeat = listt
        .map((si) => {
          return si - 3;
        })
        .reduce((a, b) => {
          return a + b;
        });
    } else {
      numRepeat = 0;
    }
    let strIndex = [];
    Array.from(new Set(strRepeat)).length > 0
      ? Array.from(new Set(strRepeat)).reduce((a, b, index) => {
          if (b - a !== 1) {
            strIndex.push(index - 1);
          }
          return b;
        })
      : strIndex;
    if (strIndex.length > 0) {
      strIndex.unshift(0);
      strIndex.push(
        Array.from(new Set(strRepeat))[
          Array.from(new Set(strRepeat)).length - 1
        ]
      );
      let lists = [];
      strIndex.reduce((a, b) => {
        lists.push(b - a);
        return b;
      });
      strRepeat = lists
        .map((si) => {
          return si - 3;
        })
        .reduce((a, b) => {
          return a + b;
        });
    } else {
      strRepeat = 0;
    }
    // 通过格式和自增判断连续
    let seqNum = [],
      seqStr = [];
    value.split("").reduce((a, b, index) => {
      if (
        _this.myIsNaN(Number(a)) &&
        _this.myIsNaN(Number(b)) &&
        Math.abs(Number(a) - Number(b)) === 1
      ) {
        seqNum.push(index - 1);
        seqNum.push(index);
      } else if (
        /[A-Za-z]/g.test(a) &&
        /[A-Za-z]/g.test(b) &&
        Math.abs(a.charCodeAt() - b.charCodeAt()) === 1
      ) {
        seqStr.push(a);
        seqStr.push(b);
      }
      return b;
    });
    seqNum = Array.from(new Set(seqNum));
    seqStr = Array.from(new Set(seqStr)).map((si) => {
      return si.charCodeAt();
    });
    // 不重复连续数组
    // 判断是否连续超过三个
    let seqNumCount = 0,
      seqStrCount = 0;
    seqNum.forEach((si) => {
      si = Number(si);
      if (seqNum.indexOf(si + 2) > -1) {
        seqNumCount++;
      } else if (seqNum.indexOf(si + 1) > -1 && seqNum.indexOf(si - 1) > -1) {
        seqNumCount++;
      } else if (seqNum.indexOf(si - 2) > -1) {
        seqNumCount++;
      }
    });
    seqStr.forEach((si) => {
      si = Number(si);
      if (seqStr.indexOf(si + 2) > -1) {
        seqStrCount++;
      } else if (seqStr.indexOf(si + 1) > -1 && seqStr.indexOf(si - 1) > -1) {
        seqStrCount++;
      } else if (seqStr.indexOf(si - 2) > -1) {
        seqStrCount++;
      }
    });

    let score =
      num +
      (value.length - 8) * 4 +
      (Aalength - ALength) * (Aalength - (Aalength - ALength)) * 2 -
      repeatList.length * 2 -
      numRepeat -
      strRepeat -
      seqNumCount * 3 -
      seqStrCount * 3;
    return score;
  },
  myBrowser: function() {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串

    var isOpera = userAgent.indexOf("Opera") > -1;

    if (isOpera) {
      return "Opera";
    } //判断是否Opera浏览器

    if (userAgent.indexOf("Firefox") > -1) {
      return "FF";
    } //判断是否Firefox浏览器

    if (userAgent.indexOf("Chrome") > -1) {
      return "Chrome";
    }

    if (userAgent.indexOf("Safari") > -1) {
      return "Safari";
    } //判断是否Safari浏览器

    if (
      (userAgent.indexOf("compatible") > -1 &&
        userAgent.indexOf("MSIE") > -1 &&
        !isOpera) ||
      userAgent.indexOf("rv:11.0") > -1
    ) {
      if (userAgent.indexOf("MSIE 6.0") > 0) {
        return "IE6";
      }

      if (userAgent.indexOf("MSIE 7.0") > 0) {
        return "IE7";
      }

      if (
        userAgent.indexOf("MSIE 8.0") > 0 ||
        (userAgent.indexOf("MSIE 9.0") > 0 && !window.innerWidth)
      ) {
        return "IE8";
      }

      if (userAgent.indexOf("MSIE 9.0") > 0) {
        return "IE9";
      }

      if (userAgent.indexOf("MSIE 10.0") > 0) {
        return "IE10";
      }

      if (userAgent.indexOf("MSIE 11.0") > 0) {
        return "IE11";
      }

      return "IE";
    } //判断是否IE浏览器

    return "other";
  },
  browserRedirect: function() {
    var sUserAgent = navigator.userAgent;
    var isWin =
      navigator.platform == "Win32" || navigator.platform == "Windows";
    var isMac =
      navigator.platform == "Mac68K" ||
      navigator.platform == "MacPPC" ||
      navigator.platform == "Macintosh" ||
      navigator.platform == "MacIntel";
    if (isMac) return "Mac";
    var isUnix = navigator.platform == "X11" && !isWin && !isMac;
    if (isUnix) return "Unix";
    var isLinux = String(navigator.platform).indexOf("Linux") > -1;
    if (isLinux) return "Linux";
    if (isWin) {
      var isWin2K =
        sUserAgent.indexOf("Windows NT 5.0") > -1 ||
        sUserAgent.indexOf("Windows 2000") > -1;
      if (isWin2K) return "Win2000";
      var isWinXP =
        sUserAgent.indexOf("Windows NT 5.1") > -1 ||
        sUserAgent.indexOf("Windows XP") > -1;
      if (isWinXP) return "WinXP";
      var isWin2003 =
        sUserAgent.indexOf("Windows NT 5.2") > -1 ||
        sUserAgent.indexOf("Windows 2003") > -1;
      if (isWin2003) return "Win2003";
      var isWinVista =
        sUserAgent.indexOf("Windows NT 6.0") > -1 ||
        sUserAgent.indexOf("Windows Vista") > -1;
      if (isWinVista) return "WinVista";
      var isWin7 =
        sUserAgent.indexOf("Windows NT 6.1") > -1 ||
        sUserAgent.indexOf("Windows 7") > -1;
      if (isWin7) return "Win7";
      var isWin10 =
        sUserAgent.indexOf("Windows NT 10") > -1 ||
        sUserAgent.indexOf("Windows 10") > -1;
      if (isWin10) return "Win10";
    }
    return "other";
  },
};

export default EventSet;



// WEBPACK FOOTER //
// ./src/assets/PubJs/hcPub.js